import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_single');
    return (
        <div className="sp-220-single-A">
            <div className="banner-img">
                <EFPicture
                    src={'/responsive/picture/solar-panel-220w-single/1.jpg'}
                    srcPad={'/responsive/picture/solar-panel-220w-single/1_768.jpg'}
                    srcMobile={'/responsive/picture/solar-panel-220w-single/1_768.jpg'}
                    alt={t('A_title')}
                />
                <p className="banner-title">{t('A_title')}</p>
            </div>
        </div>
    );
}
